/**
 * Route for `braze-iterable-customer-io-integrations`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { BrazeIterableCustomerIoIntegrationsPage } from "../features/braze-iterable-customer-io-integrations/BrazeIterableCustomerIoIntegrationsPage";

export const brazeIterableCustomerIoIntegrationsRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/braze-iterable-customer-io-integrations",
	component: BrazeIterableCustomerIoIntegrationsPage,
});

export default brazeIterableCustomerIoIntegrationsRoute;
